import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DocumentsServe, TabSize } from 'src/app/utils/constants';
import { PageTab } from 'src/app/utils/enums';
import { PublicCardData, Usuario } from 'src/app/utils/models';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-center-card',
  templateUrl: './center-card.component.html',
  styleUrls: ['./center-card.component.scss'],
})
export class CenterCardComponent implements OnChanges, OnInit {
  @Input() currentTab: number;
  @Input() publicCardData: PublicCardData;
  @Input() usuario: Usuario;
  @Output() currentTabChange: EventEmitter<number>;
  @Output() statusScroll: EventEmitter<number>;
  cache: string;
  coverImage: string;
  logoImage: string;
  coverImagePaddingTop: number;

  constructor() {
    this.usuario = new Usuario();
    this.currentTab = PageTab.PRESENTATION;
    this.publicCardData = new PublicCardData();
    this.statusScroll = new EventEmitter<number>();
    this.currentTabChange = new EventEmitter<number>();
    this.cache = '?nocache=' + Math.random();
    this.coverImage = '';
    this.logoImage = '';
    this.coverImagePaddingTop = 0;
  }
  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('publicCardData' in changes) {
      if (this.usuario.empresa.configuracionEmpresa.urlBanner !== null && this.usuario.empresa.configuracionEmpresa.urlLogotipo !== null ) {

        var banner: any;
        var logotipo: any;

        if(this.usuario.empresa.configuracionEmpresa.urlBanner == ""){
          banner = this.usuario.tarjetaPortada.urlBanner;
          this.coverImage = DocumentsServe.COVERPHOTOS + this.publicCardData.idTarjeta + '/' + this.publicCardData.urlBanner + this.cache;
        }else{
          banner = this.usuario.empresa.configuracionEmpresa.urlBanner;
          this.coverImage =`https://tarjetasf.virtualplace.online/Empresas/Configuracion/${banner}`;
        }

        if (this.usuario.empresa.configuracionEmpresa.urlBanner == "" && this.usuario.tarjetaPortada.urlBanner == "") {
          this.coverImage = `../../../../../assets/img/imagge.jpg`;
        }

        if(this.usuario.empresa.configuracionEmpresa.urlLogotipo == ""){
          logotipo = this.usuario.tarjetaPortada.urlLogotipo;
          this.logoImage = DocumentsServe.COVERPHOTOS + this.publicCardData.idTarjeta + '/' + this.publicCardData.urlLogotipo + this.cache;
        }else{
          logotipo = this.usuario.empresa.configuracionEmpresa.urlLogotipo;
          this.logoImage = `https://tarjetasf.virtualplace.online/Empresas/Configuracion/${logotipo}`;
        }

        if (this.usuario.empresa.configuracionEmpresa.urlLogotipo == "" && this.usuario.tarjetaPortada.urlLogotipo == "") {
          this.logoImage = ``;
        }

        // this.coverImage =`https://tarjetasf.virtualplace.online/Empresas/Configuracion/${banner}`;
        // this.logoImage = `https://tarjetasf.virtualplace.online/Empresas/Configuracion/${logotipo}`;
        
        return;
      }
    }
  }

  getMeta(url: string, callback: any) {
    //console.log(url);

    const img = new Image();
    img.src = url;
    img.onload = function () {
      callback(img.width, img.height);
    };
  }

  goToAboutMe(): void {
    this.statusScroll.emit(0);
    this.currentTab = PageTab.ABOUTME;
    this.currentTabChange.emit(PageTab.ABOUTME);
  }

  goToService(): void {
    const position = (window.innerWidth * 100 * 2) / 100;

    this.statusScroll.emit(position);
    this.currentTab = PageTab.SERVICES;
    this.currentTabChange.emit(PageTab.SERVICES);
  }

  goToCenter(): void {
    const position = (window.innerWidth * TabSize.SIZE) / 100;
    this.statusScroll.emit(position);
    this.currentTab = PageTab.PRESENTATION;
    this.currentTabChange.emit(PageTab.PRESENTATION);
  }

  changeOrientation() {
    // const body = new CoverPage();
    // body.colorTarjeta = this.colorPage;
    // body.colorLetra = this.colorText;
    // body.colorFlecha = form.colorFlecha;
    // body.fondoFlecha = form.fondoFlecha;
    // body.idTarjeta = String(this.data.idTarjeta);
    // body.idUsuario = String(this.data.idUsuario);
    // body.idioma = this.publicData.idioma;
    // const request = this.publicData.createCoverPage(body);
    // request.subscribe((response) => {
    //   if (response.status === 1 && response.message === 'OK') {
    //     this.data.colorLetra = body.colorLetra;
    //     this.data.colorTarjeta = body.colorTarjeta;
    //     this.data.colorFlecha = body.colorFlecha;
    //     this.data.fondoFlecha = body.fondoFlecha;
    //     // this.sendSuccess();
    //     this.matDialogRef.close({ msg: 'success', data: this.data });
    //   }
    // });
  }
}
